import classNames from "classnames"
import React, { useMemo, useRef } from "react"

import LayoutSection from "../LayoutComponents/LayoutSection"
import LayoutItem from "../Layouts/LayoutItem"

import { Color } from "@constants/V2/color"
import { useElementObserver } from "@hooks/V2/useElementObserver"

type Props = {
  text: string
  highlightedText?: string
  mobileGridOrder?: number
}

const TypingText = ({ text, highlightedText, mobileGridOrder }: Props) => {
  const layoutSectionRef = useRef<HTMLDivElement>(null)
  const { isVisible, startObserving } = useElementObserver(layoutSectionRef)

  const individualCharacters = useMemo(() => {
    const transitionDelay = 7 // in MS
    const splitTextList = text.split("")

    return [
      ...splitTextList,
      ...(highlightedText ? [" ", ...highlightedText.split("")] : []),
    ].map((char, index) => (
      <span
        key={`split-text-${index}`}
        className={classNames(
          "text-responsive-h4 font-normal opacity-20 transition-all",
          index < splitTextList.length
            ? "typing-text"
            : "highlighted-typing-text"
        )}
        style={{
          transitionDelay: `${(index + 1) * transitionDelay}ms`,
        }}
      >
        {char}
      </span>
    ))
  }, [text, highlightedText])

  if (isVisible && layoutSectionRef.current) {
    for (const span of Array.from(
      layoutSectionRef.current.querySelectorAll(".typing-text")
    )) {
      span.classList.replace("opacity-20", "opacity-100")
    }

    if (highlightedText) {
      for (const span of Array.from(
        layoutSectionRef.current.querySelectorAll(".highlighted-typing-text")
      )) {
        span.classList.replace("opacity-20", "opacity-100")
        span.classList.add("text-blue")
      }
    }
  }

  startObserving()

  return (
    <LayoutItem
      as={LayoutSection}
      ref={layoutSectionRef}
      primaryBackgroundColor={Color.White}
      mobileGridOrder={mobileGridOrder}
    >
      <p>{individualCharacters}</p>
    </LayoutItem>
  )
}

export default TypingText
